import '../../store';

export default {
    data() {
        return {
            amount: 0,
            makingBid: false,
        };
    },

    methods: {
        makeBid(auctionId) {
            this.makingBid = true;

            $.ajax({
                url: route('storefront.auctions.bid', auctionId),
                type: 'POST',
                data: {
                    amount: this.amount,
                }
            }).then(response => {
                console.log(response);
                this.$notify(response.message);
                this.amount = 0;
            }).catch((xhr) => {
                console.log(xhr.responseJSON.message);
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.makingBid = false;
            });
        }
    }
};
